import type { AnnouncementSlug } from "../../../../api/src/shared/domain/announcement";
import type { AnnouncementProps } from "./types";
import { FeedAnnouncement } from "./FeedAnnouncement";
import { HealthyHourBrafAnnouncement } from "./HealthyHourBrafAnnouncement";
import { JuisciGptAnnouncement } from "./JuisciGptAnnouncement";

/**
 * Which component each slug in the catalogue is.
 *
 * `satisfies Record<AnnouncementSlug, ...>` is the load-bearing part: adding a
 * slug to `shared/domain/announcement.ts` without writing its component fails
 * the build here rather than reaching a reader as an empty sheet. That is the
 * whole reason announcements left the database. An announcement is a design, and
 * a design that does not exist should not be schedulable.
 *
 * The api serves SLUGS and nothing else, so this map is the only place that
 * decides what a reader actually sees.
 */
export const ANNOUNCEMENT_COMPONENTS = {
  "juisci-gpt": JuisciGptAnnouncement,
  feed: FeedAnnouncement,
  "healthy-hour-braf": HealthyHourBrafAnnouncement,
} as const satisfies Record<
  AnnouncementSlug,
  (props: AnnouncementProps) => React.JSX.Element
>;
